import { KeyboardEvent } from 'react'

export function callbackOnPressKey(
  event: KeyboardEvent<HTMLDivElement | HTMLSpanElement>,
  callback: () => Promise<void> | void
): void {
  if (event.key === 'Enter') callback()
}
